import { all, call } from 'redux-saga/effects';

import patientAnalysesSaga from './modules/patientAnalysis/saga';

export function* saga() {
  yield all([
    call(patientAnalysesSaga),
  ]);
}
